// extracted by mini-css-extract-plugin
export var button = "_97-0";
export var icon = "_97-1";